import { ReactElement, useMemo, useState } from 'react';

import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { AdditionalEntitlement } from '~libs.shared.prescription';
import { isEmpty } from '~libs.typescript';

import { PatientPrescriptionsHistoryDownloadVerificationModal } from './PatientPrescriptionsHistoryDownloadVerificationModal';

type PatientPrescriptionsHistoryDownloadVerificationModalProps = {
   readonly visitId: number;
   readonly documentationScope: Visit['documentationScope'];
};

type UsePatientPrescriptionsHistoryDownloadVerificationModalOutput = {
   openPatientPrescriptionsHistoryDownloadVerificationModal: (additionalEntitlements: AdditionalEntitlement[]) => void;
   renderPatientPrescriptionsHistoryDownloadVerificationModal: (
      props: PatientPrescriptionsHistoryDownloadVerificationModalProps
   ) => ReactElement | null;
};

export const usePatientPrescriptionsHistoryDownloadVerificationModal = (): UsePatientPrescriptionsHistoryDownloadVerificationModalOutput => {
   const [additionalEntitlements, setAdditionalEntitlements] = useState<AdditionalEntitlement[] | null>(null);

   return useMemo(
      () => ({
         openPatientPrescriptionsHistoryDownloadVerificationModal: setAdditionalEntitlements,
         renderPatientPrescriptionsHistoryDownloadVerificationModal: (props) => {
            if (isEmpty(additionalEntitlements)) {
               return null;
            }

            return (
               <PatientPrescriptionsHistoryDownloadVerificationModal
                  additionalEntitlements={additionalEntitlements}
                  visitId={props.visitId}
                  documentationScope={props.documentationScope}
                  onClose={() => {
                     setAdditionalEntitlements(null);
                  }}
               />
            );
         },
      }),
      [additionalEntitlements]
   );
};
